// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"b0b02d2ef10324aef54c","147":"17727bebf47b231ab345","251":"eefd4799fe4e82a86f89","352":"d63a2b9da06a2a6b9514","544":"da2e9679d2efe0ea37eb"}[chunkId] + ".js";
};